import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, dynamicFormType, rowConfig, usedFileType }) => {
    return {
      name,
      type: formType,
      label: fieldName,
      placeholder,
      validation,
      className,
      hidden,
      dynamicFormType,
      usedFileType
    };
  });
};


let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    fields = {
        landingPageHeading: mapFields(data?.landingPageHeading || []),
        practisingSensibleEconomicsPageHeading: mapFields(data?.practisingSensibleEconomicsPageHeading || []),
        environmentalConsciousnessPageHeading: mapFields(data?.environmentalConsciousnessPageHeading || []),
        creatingInspiringWorkplacePageHeading: mapFields(data?.creatingInspiringWorkplacePageHeading ||[]),
        communityFriendlyOrganisationPageHeading: mapFields(data?.communityFriendlyOrganisationPageHeading || []),
        memorableAirportExperiencesPageHeading: mapFields(data?.memorableAirportExperiencesPageHeading || []),
        ftse4GoodPageHeading: mapFields(data?.ftse4GoodPageHeading || []),
        reportsPageHeading: mapFields(data?.reportsPageHeading ||[]),
        reportsFeatures: data?.reportsFeatures?.map((data: ModuleFields[])=>{
                  return mapFields(data);
          }),
        reportsMainContent: mapFields(data?.reportsMainContent),
    };
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
